export enum OrganizationMetadataType {
  ApplicationType,
  OrganizationType,
  BusinessSummary,
  AssessmentType,
  CorrelationId,
  CompanyType,
  TradingName,
  PreferredLanguage
}

export enum OrganizationRegistrationNumberType {
  CompanyRegistrationNumber,
  ABN,
  ACN,
  VATRegistrationNumber,
  FedTaxId
}

interface IOrganizationMetadata {
  typeId: OrganizationMetadataType;
  value: string | null;
}

interface IOrganizationRegistrationNumbers {
  typeId: OrganizationRegistrationNumberType;
  value: string | null;
}

export interface IOrganizationWithMetadata {
  id: string;
  legacyId: string;
  name: string;
  shortName: string | null;
  taxPayerIdNumber: string | null;
  website: string | null;
  organizationMetadatas: IOrganizationMetadata[];
  organizationRegistrationNumbers: IOrganizationRegistrationNumbers[];
}
